import { requestGet } from '@/client'

export const getPhoto = (photoId) => requestGet(`photos/${photoId}`)

export default { getPhoto }
